"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92239],{

/***/ 750180:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var useSWR = __webpack_require__(497691);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var useSWR__default = /*#__PURE__*/_interopDefaultLegacy(useSWR);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useDiscoverySearchV2 = (discoveryService, params, configs, searchAlgoHeaderValue) => {
  const _a = configs || {}, { transform = (data2) => data2 } = _a, swrConfigs = __objRest(_a, ["transform"]);
  const { data, error } = useSWR__default["default"](params && Object.keys(params).length ? [params, "discovery-search-v2"] : null, async (params2) => {
    const response = await discoveryService.search(params2, searchAlgoHeaderValue);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  return {
    result: data,
    error,
    loading: params && Object.keys(params).length ? !error && !data : false
  };
};

exports.t = useDiscoverySearchV2;


/***/ }),

/***/ 802705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ RefreshOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const RefreshOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19.3719 2.48965C19.3498 2.07603 18.9965 1.75869 18.5829 1.78085C18.1693 1.80301 17.8519 2.15628 17.8741 2.5699L17.9659 4.28366C16.3174 3.00646 14.2461 2.24608 12 2.24608C6.61584 2.24608 2.25 6.61081 2.25 11.9961C2.25 17.3814 6.61584 21.7461 12 21.7461C17.3852 21.7461 21.75 17.3813 21.75 11.9961C21.75 11.3831 21.6938 10.7832 21.5854 10.2C21.5097 9.79279 21.1182 9.52402 20.7109 9.59971C20.3037 9.67541 20.0349 10.0669 20.1106 10.4741C20.2022 10.967 20.25 11.4751 20.25 11.9961C20.25 16.5529 16.5568 20.2461 12 20.2461C7.44416 20.2461 3.75 16.5528 3.75 11.9961C3.75 7.43935 7.44416 3.74608 12 3.74608C13.9066 3.74608 15.6616 4.39206 17.0582 5.47795L15.1388 5.52197C14.7247 5.53147 14.3967 5.87486 14.4062 6.28897C14.4157 6.70307 14.7591 7.03107 15.1732 7.02158L18.8362 6.93758C19.039 6.93293 19.2313 6.84629 19.3692 6.69745C19.5071 6.5486 19.5788 6.35025 19.5679 6.14765L19.3719 2.48965Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 260613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BuildPcNumberStepper; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(650983);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(589561);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(580871);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);



const StyledStepper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ color }) => `
    display: flex;
    align-items: center;
    border-radius: 0.25rem;
    border: 1px solid ${color};
    align-items: center;
    overflow: hidden;
    background: #fff;
    justify-content: space-between;
  `);
const Value = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ color }) => `
    flex: 1;
    color: ${color};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  `);
const StyledButton = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)(({ color }) => `
    line-height: 1;
    color: ${color};
    font-size: 1rem;
    border: none;
    padding: 0;
    align-self: stretch;
    padding: 0.5rem;
    border-radius: 0;
    --button-icon-color: ${color};
`);
const Sign = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.span */ .z.span`
  display: inline-block;
  width: 1rem;
  height: 1rem;
`;
const StyledInput = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Input */ .I)(({ color }) => `
  padding: 0;
  color: ${color};
  width: 2rem;
  border: none;
  text-align: center;
`);
const handleFocus = (event) => event.target.select();
const BuildPcNumberStepper = ({
  value,
  minimumValue,
  maximumValue,
  stepValue = 1,
  onIncrease,
  onDecrease,
  setValue,
  className,
  showDeleteIcon = true,
  variant = "primary",
  primaryColor
}) => {
  var _a, _b;
  const theme = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .F)();
  const color = variant === "primary" ? ((_a = theme.brand) == null ? void 0 : _a.primary) || primaryColor : theme.colors.dark;
  const borderColor = variant === "primary" ? ((_b = theme.brand) == null ? void 0 : _b.primary) || primaryColor : theme.colors.gray300;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledStepper, {
    className,
    color: borderColor
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    color,
    outline: true,
    onClick: onDecrease,
    disabled: minimumValue ? value - stepValue < minimumValue : false,
    icon: value === 1 && showDeleteIcon ? {
      name: "trash",
      size: 16
    } : null
  }, (!showDeleteIcon || value > 1 || !value) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sign, null, "-")), setValue ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, {
    type: "number",
    onChange: (e) => setValue(parseInt(e.target.value)),
    value,
    color,
    onFocus: handleFocus
  }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Value, {
    color
  }, value), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButton, {
    color,
    variant,
    outline: true,
    onClick: onIncrease,
    disabled: maximumValue ? value + stepValue > maximumValue : false
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Sign, null, "+")));
};




/***/ }),

/***/ 73586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ProductName; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(334751);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(173698);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ProductName = (_a) => {
  var _b = _a, {
    name,
    status,
    needManageStock,
    totalAvailableByStocks = 0,
    isFlashSelling = false,
    tag
  } = _b, props = __objRest(_b, [
    "name",
    "status",
    "needManageStock",
    "totalAvailableByStocks",
    "isFlashSelling",
    "tag"
  ]);
  const NameTag = StyledProductName.withComponent(tag ? tag : "div");
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(NameTag, __spreadProps(__spreadValues({}, props), {
    maxLines: totalAvailableByStocks > 0 && totalAvailableByStocks < 5 ? 2 : 3
  }), status && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, __spreadValues({}, __spreadProps(__spreadValues({}, status), { children: status.value, variant: "primary" }))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledH3, null, name)), !isFlashSelling && needManageStock && totalAvailableByStocks > 0 && totalAvailableByStocks < 5 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RemainingProduct, null, (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_1__.t)("Ch\u1EC9 c\xF2n {{totalAvailableByStocks}} s\u1EA3n ph\u1EA9m", {
    totalAvailableByStocks
  })));
};
const StyledProductName = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ maxLines = 3 }) => `
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${maxLines};
  font-size: 13px;
`);
const StyledTag = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Tag */ .V)(({ color }) => `
  margin-right: 0.2rem;
  background-color: ${color};
  padding: 1px 0.4rem;
  font-size: 13px;
  font-weight: 400;
  padding: 2px 8px;
  border-radius: 4px;
`);
const RemainingProduct = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  color: #d9852b;
  font-size: 0.75rem;
  margin-top: 2px;
  margin-bottom: 8px;
  line-height: 1rem;
`;
const StyledH3 = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.h3 */ .z.h3`
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1rem;
  display: inline;
`;




/***/ }),

/***/ 770024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ProductPrice; }
/* harmony export */ });
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(855271);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(526439);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, ({ theme }) => `
  display: flex;
  justify-content: space-between;
  --button-icon-color: ${theme == null ? void 0 : theme.colors.green400};
  `);
const PriceWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  flex-direction: ${(props) => props.horizontal ? "" : "column"};
  align-items: baseline;
`;
const Price = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F)((props) => {
  var _a, _b;
  return `
  margin-bottom: ${props.size === "lg" ? "0.5rem" : "0"};
  font-size: ${props.size === "md" ? "1rem" : "1.75rem"};
  font-weight: 500;
  color: ${(_b = (_a = props.theme) == null ? void 0 : _a.brand) == null ? void 0 : _b.primary};
  font-weight: bold;
`;
});
const DiscountWrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const ListedPrice = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .Currency */ .F)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme.colors.gray130};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const Discount = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.span */ .z.span(({ theme }) => {
  var _a;
  return `
  font-size: 0.75rem;
  color: ${(_a = theme == null ? void 0 : theme.brand) == null ? void 0 : _a.secondary};
  margin-left: 6px;
`;
});
const EditIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l)(({ theme }) => `
    width: 1.25rem;
    height: 1.25rem;
    margin-left: 0.25rem;
    background-color: ${theme == null ? void 0 : theme.colors.link500};
  `);
const PriceEditIcon = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div`
  display: flex;
  flex-direction: row;
`;
const ProductPrice = (_a) => {
  var _b = _a, {
    price,
    discount,
    horizontal = false,
    size = "md",
    className,
    unitPrice,
    listedPrice,
    consultationServiceFee = 0,
    isPriceEditable = false,
    onEditPrice
  } = _b, props = __objRest(_b, [
    "price",
    "discount",
    "horizontal",
    "size",
    "className",
    "unitPrice",
    "listedPrice",
    "consultationServiceFee",
    "isPriceEditable",
    "onEditPrice"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    className
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PriceWrapper, {
    horizontal
  }, price !== null && price !== void 0 && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PriceEditIcon, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Price, {
    className: "price",
    size,
    value: price
  }), isPriceEditable && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(EditIcon, {
    name: "edit",
    onClick: onEditPrice
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DiscountWrapper, null, unitPrice && unitPrice !== price - consultationServiceFee && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListedPrice, {
    className: "listed-price",
    horizontal,
    size,
    value: unitPrice,
    lineThrough: true
  }), !!listedPrice && listedPrice !== price && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ListedPrice, {
    className: "listed-price",
    horizontal,
    size,
    value: listedPrice,
    lineThrough: !!listedPrice && listedPrice !== price
  }), !!discount && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Discount, {
    className: "discount"
  }, discount))));
};




/***/ }),

/***/ 792239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ CustomHamper; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/RefreshOutlined.es.js
var RefreshOutlined_es = __webpack_require__(802705);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(982226);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../packages/tracking/dist/helper.es.js
var helper_es = __webpack_require__(428247);
// EXTERNAL MODULE: ../../packages/utils/dist/object.es.js
var object_es = __webpack_require__(535820);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/HamperContext.tsx
var HamperContext = __webpack_require__(626650);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(855271);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_Button_es = __webpack_require__(650983);
;// CONCATENATED MODULE: ./components/mobile/organisms/CustomHamper/components/HamperTabs.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow-x: scroll;\n  a {\n    text-decoration: unset;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  height: 40px;\n  width: 30%;\n  margin-right: 8px;\n  margin-top: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



const Wrapper = styled_es/* styled.div */.z.div(_templateObject());
const StyledButton = (0,styled_es/* styled */.z)(Button_Button_es/* Button */.z)(_templateObject1());
const HamperTabs = (_param)=>{
    var { onClickTab , lsActiveTab  } = _param, props = _objectWithoutProperties(_param, [
        "onClickTab",
        "lsActiveTab"
    ]);
    const {} = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, _objectSpreadProps(_objectSpread({}, props), {
        children: Array(5).fill(null).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledButton, {
                variant: index === lsActiveTab ? "primary" : "normal",
                onClick: ()=>{
                    onClickTab && onClickTab(index);
                },
                children: [
                    (0,i18n.t)("Giỏ qu\xe0 tự chọn"),
                    " ",
                    index + 1
                ]
            }, "".concat(index)))
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/InforFilled.es.js
var InforFilled_es = __webpack_require__(250926);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Quantity/Quantity.es.js
var Quantity_es = __webpack_require__(280392);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Card/Card.es.js
var Card_es = __webpack_require__(319326);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductPrice/ProductPrice.es.js
var ProductPrice_es = __webpack_require__(770024);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/Common/ProductName/ProductName.es.js
var ProductName_es = __webpack_require__(73586);
// EXTERNAL MODULE: ./helpers/hamper.ts
var hamper = __webpack_require__(282116);
;// CONCATENATED MODULE: ./components/mobile/organisms/CustomHamper/components/HamperSummary.tsx
function HamperSummary_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HamperSummary_templateObject() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  padding: 1rem 2rem;\n  text-align: center;\n  margin-bottom: 16px;\n"
    ]);
    HamperSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HamperSummary_templateObject1() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  min-height: unset;\n  margin-left: 0.3rem;\n  color: rgb(235, 33, 1);\n  span {\n    font-size: 1.25rem;\n  }\n"
    ]);
    HamperSummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  margin-top: 0.875rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  padding: 12px 8px;\n  background-color: #fff6ec;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  transition: 0.2s;\n  &.active {\n    transform: rotate(180deg);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 16px;\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 16px;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  height: 1.5rem;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  padding: 8px;\n  margin-top: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n  :hover {\n    background-color: #f3f4f6;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  color: #82869e;\n  font-weight: 400;\n  font-size: 12px;\n  text-align: left;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  span {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 14px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    const data = HamperSummary_taggedTemplateLiteral([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}








const HamperSummary = ()=>{
    const { updateCurrentConfig , increaseCurrentHamperQuantity , decreaseCurrentHamperQuantity , setCurrentHamperQuantity , priceSummary , priceAvailableHamper , allPriceSummary , handleBuyNowHamper , availableHamper , addHamper , removeHamper , minusHamper , onChangeQuantityHamper ,  } = (0,HamperContext/* useHamper */.h)();
    const { zaloUrl  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const countHamper = priceSummary.reduce((prev, cur)=>{
        return prev + cur.quantity;
    }, 0);
    const countAvailableHamper = availableHamper === null || availableHamper === void 0 ? void 0 : availableHamper.reduce((prev, cur)=>{
        return prev + cur.quantity;
    }, 0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,i18n.t)("Tổng gi\xe1 trị đơn h\xe0ng")
                    }),
                    !!allPriceSummary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        marginTop: "s16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    (0,i18n.t)("Giỏ qu\xe0 tự chọn"),
                                    " (",
                                    countHamper,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                price: allPriceSummary
                            })
                        ]
                    }),
                    !!priceAvailableHamper && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        marginTop: "s16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    (0,i18n.t)("Giỏ qu\xe0 g\xf3i sẵn"),
                                    " (",
                                    countAvailableHamper,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                price: priceAvailableHamper
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                        color: "#f0f0f0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                                children: (0,i18n.t)("Tổng tạm t\xednh")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                price: allPriceSummary + (priceAvailableHamper || 0)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperSummary_StyledButton, {
                        variant: "primary",
                        block: true,
                        onClick: handleBuyNowHamper,
                        children: (0,i18n.t)("Mua ngay")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        href: zaloUrl,
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperSummary_StyledButton, {
                            variant: "default",
                            block: true,
                            children: (0,i18n.t)("Nhận tư vấn")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                        color: "#f0f0f0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitle, {
                                children: [
                                    " ",
                                    (0,i18n.t)("Giỏ qu\xe0 tự chọn")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    "(",
                                    priceSummary.length,
                                    "/",
                                    hamper/* MAXIMUM_COUNT_HAMPER */.JQ,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    priceSummary.map((p, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHamper, {
                            direction: "column",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    width: "100%",
                                    justify: "space-between",
                                    align: "middle",
                                    marginTop: "s16",
                                    children: [
                                        (0,i18n.t)("Giỏ qu\xe0 tự chọn"),
                                        " ",
                                        p.index + 1,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity_es/* Quantity */.h, {
                                            quantity: p.quantity,
                                            setQuantity: (newQuantity)=>setCurrentHamperQuantity(newQuantity, p.index),
                                            onMinus: p.quantity === 1 ? ()=>updateCurrentConfig({}, p.index) : ()=>decreaseCurrentHamperQuantity(p.index),
                                            onPlus: ()=>increaseCurrentHamperQuantity(p.index),
                                            min: 0,
                                            max: 999,
                                            color: "primary500"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsCollapse, {
                                    products: p.products
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    justify: "space-between",
                                    width: "100%",
                                    align: "middle",
                                    children: [
                                        (0,i18n.t)("Chi ph\xed dự kiến"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Total, {
                                            price: p.price
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                        color: "#f0f0f0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                        justify: "space-between",
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                                children: (0,i18n.t)("Giỏ qu\xe0 g\xf3i sẵn")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                                children: [
                                    "(",
                                    availableHamper.length,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    availableHamper.map((ah)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    justify: "start",
                                    marginTop: "s8",
                                    width: "100%",
                                    direction: "row",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                            width: 64,
                                            height: 64,
                                            src: ah === null || ah === void 0 ? void 0 : ah.imageUrl,
                                            border: true,
                                            borderRadius: 8,
                                            contain: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                            direction: "column",
                                            justify: "start",
                                            width: "50%",
                                            paddingLeft: "s4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                                                numberOfLine: 2,
                                                name: ah.name || (0,i18n.t)("T\xean sản phẩm đang được cập nhật")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                            direction: "row",
                                            justify: "end",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity_es/* Quantity */.h, {
                                                quantity: ah.quantity,
                                                setQuantity: (q)=>onChangeQuantityHamper(ah.sku, q),
                                                onMinus: ()=>ah.quantity === 1 ? removeHamper(ah.sku) : minusHamper(ah.sku),
                                                onPlus: ()=>addHamper(ah.sku),
                                                min: 0,
                                                max: 999,
                                                color: "primary500"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                    direction: "column",
                                    width: "100%",
                                    justify: "end",
                                    align: "end",
                                    marginTop: "s12",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrice, {
                                        price: ah.price * (ah.quantity || 1)
                                    })
                                })
                            ]
                        }, ah.sku);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningCard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    direction: "row",
                    align: "center",
                    justify: "start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InforFilled_es/* InforFilled */._, {
                            size: 24,
                            color: "#FAAD14"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                            width: "90%",
                            marginLeft: "s12",
                            direction: "column",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                level: 1,
                                weight: "regular",
                                color: "warning",
                                children: (0,i18n.t)("Đối với giỏ qu\xe0 tự chọn, mức gi\xe1 hiển thị chưa bao gồm khay v\xe0 nơ. Si\xeau thị sẽ li\xean hệ Qu\xfd kh\xe1ch để tư vấn v\xe0 x\xe1c nhận chi ph\xed trước khi đ\xf3ng g\xf3i")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const StyledCard = (0,emotion_styled_browser_esm["default"])(Card_es/* Card */.Z)(HamperSummary_templateObject());
const Total = (0,emotion_styled_browser_esm["default"])(ProductPrice_es/* ProductPrice */.j)(HamperSummary_templateObject1());
const HamperSummary_StyledButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)(_templateObject2());
const WarningCard = (0,emotion_styled_browser_esm["default"])(Card_es/* Card */.Z)(_templateObject3());
const ProductsCollapse = (param)=>{
    let { products =[]  } = param;
    const { 0: show , 1: setShow  } = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollapseHeader, {
                onClick: ()=>setShow(!show),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* SubTitle */.DK, {
                        color: "#82869e",
                        level: 4,
                        weight: "medium",
                        children: [
                            (0,i18n.t)("Xem chi tiết"),
                            " (",
                            products.length,
                            " ",
                            (0,i18n.t)("sản phẩm"),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDownOutlined, {
                        className: show ? "active" : "",
                        color: "textPrimary"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollapseContent, {
                className: show ? "active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
                    direction: "column",
                    children: products.map((product, index)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductItem, {
                            justify: "start",
                            marginTop: "s8",
                            width: "100%",
                            direction: "row",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                    width: 40,
                                    height: 40,
                                    src: product === null || product === void 0 ? void 0 : product.imageUrl,
                                    border: true,
                                    borderRadius: 8,
                                    contain: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    direction: "column",
                                    justify: "start",
                                    width: "50%",
                                    paddingLeft: "s8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductName, {
                                            name: product.name || (0,i18n.t)("T\xean sản phẩm đang được cập nhật")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SKU, {
                                            children: [
                                                "SL: ",
                                                product.quantity
                                            ]
                                        })
                                    ]
                                }),
                                product.quantity && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    width: "30%",
                                    paddingLeft: "s4",
                                    justify: "start",
                                    align: "middle",
                                    children: product && product.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrice, {
                                        price: product.price.latestPrice * (product.quantity || 1)
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    });
};
const StyledDownOutlined = (0,emotion_styled_browser_esm["default"])(DownOutlined_es/* DownOutlined */.T)(_templateObject4());
const Collapse = emotion_styled_browser_esm["default"].div(_templateObject5());
const CollapseHeader = emotion_styled_browser_esm["default"].div(_templateObject6());
const CollapseContent = emotion_styled_browser_esm["default"].div((param)=>{
    let { theme  } = param;
    return "\n  height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  gap: 0.25rem;\n  &.active {\n    margin-top: ".concat(theme === null || theme === void 0 ? void 0 : theme.spacing.s12, ";\n    height: auto;\n  }\n");
});
const StyledFlex = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject7());
const StyledHamper = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject8());
const StyledProductItem = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(_templateObject9());
const StyledProductName = (0,emotion_styled_browser_esm["default"])(ProductName_es/* ProductName */.r)((param)=>{
    let { numberOfLine =1  } = param;
    return "\n  overflow: hidden;\n  text-align: left;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: ".concat(numberOfLine, ";\n");
});
const SKU = emotion_styled_browser_esm["default"].span(_templateObject10());
const StyledPrice = (0,emotion_styled_browser_esm["default"])(ProductPrice_es/* ProductPrice */.j)(_templateObject11());
const StyledTitle = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject12());
const StyledContent = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(_templateObject13());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var Shape_index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-8c60e9889a/1/packages/ecommerce/dist/BuildPc/BuildPcNumberStepper/BuildPcNumberStepper.es.js
var BuildPcNumberStepper_es = __webpack_require__(260613);
;// CONCATENATED MODULE: ./components/mobile/organisms/CustomHamper/components/HamperItem.tsx
function HamperItem_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HamperItem_templateObject() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  padding: 1.5rem 1rem;\n  margin-bottom: 16px;\n  transition: box-shadow 0.2s ease-in-out;\n  &:hover {\n    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);\n  }\n"
    ]);
    HamperItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HamperItem_templateObject1() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  height: 32px;\n  padding: 10;\n"
    ]);
    HamperItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HamperItem_templateObject2() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-items: start;\n  flex-direction: column;\n"
    ]);
    HamperItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HamperItem_templateObject3() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  color: unset;\n  text-decoration: unset;\n  font-size: 13px;\n"
    ]);
    HamperItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HamperItem_templateObject4() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  color: #757575;\n  font-size: 12px;\n"
    ]);
    HamperItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HamperItem_templateObject5() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  min-height: auto;\n  margin: 4px 0px;\n"
    ]);
    HamperItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HamperItem_templateObject6() {
    const data = HamperItem_taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  color: #1990ff;\n  font-weight: 400;\n  text-align: center;\n"
    ]);
    HamperItem_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




const HamperItem = (param)=>{
    let { title , products =[] , icon ="" , onClick , onIncrease , onDecrease , setQuantity , removeItem  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamperItem_StyledCard, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                children: title
            }),
            !products.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                justify: "space-between",
                align: "middle",
                marginTop: "s12",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                        border: "1px solid border",
                        borderRadius: "l",
                        padding: "s4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            width: 68,
                            height: 68,
                            src: icon,
                            border: true,
                            borderRadius: 8,
                            contain: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperItem_StyledButton, {
                        onClick: onClick,
                        variant: "primary",
                        children: (0,i18n.t)("Chọn")
                    })
                ]
            }),
            products === null || products === void 0 ? void 0 : products.map((product, index)=>{
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    width: "100%",
                    marginTop: "s12",
                    direction: "row",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Shape_index_es/* Shape */.b, {
                            border: "1px solid border",
                            borderRadius: "l",
                            padding: "s4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                                width: 68,
                                height: 68,
                                src: (product === null || product === void 0 ? void 0 : product.imageUrl) || icon,
                                onClick: ()=>{
                                    if (!product) onClick === null || onClick === void 0 ? void 0 : onClick();
                                },
                                borderRadius: 8,
                                contain: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NameWrapper, {
                            marginLeft: "s16",
                            width: "75%",
                            children: [
                                product ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                                            // @ts-ignore
                                            href: (ref = product.link) === null || ref === void 0 ? void 0 : (ref1 = ref.as) === null || ref1 === void 0 ? void 0 : ref1.pathname,
                                            rel: "noreferrer noopener",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName_es/* ProductName */.r, {
                                                name: product.name || (0,i18n.t)("T\xean sản phẩm đang được cập nhật")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HamperItem_SKU, {
                                            children: [
                                                "SKU: ",
                                                product.sellerSku
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (0,i18n.t)("Vui l\xf2ng chọn sản phẩm")
                                }),
                                product.quantity && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                                    children: [
                                        product && product.price && /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperItem_StyledPrice, {
                                            price: product.price.latestPrice,
                                            discount: product.price.discountPercent,
                                            listedPrice: product.price.supplierRetailPrice
                                        }),
                                        (product === null || product === void 0 ? void 0 : product.quantity) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPcNumberStepper_es/* BuildPcNumberStepper */.F, {
                                            onIncrease: ()=>{
                                                return onIncrease === null || onIncrease === void 0 ? void 0 : onIncrease(product.sku);
                                            },
                                            onDecrease: ()=>{
                                                return onDecrease === null || onDecrease === void 0 ? void 0 : onDecrease(product.sku, product.quantity);
                                            },
                                            setValue: (value)=>{
                                                return setQuantity === null || setQuantity === void 0 ? void 0 : setQuantity(value, product.sku);
                                            },
                                            value: product.quantity
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRemoveText, {
                                            onClick: ()=>{
                                                return removeItem === null || removeItem === void 0 ? void 0 : removeItem(product.sku);
                                            },
                                            children: (0,i18n.t)("Xo\xe1")
                                        })
                                    ]
                                }),
                                index === products.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                    marginTop: "s16",
                                    justify: "end",
                                    align: "end",
                                    direction: "row",
                                    width: "100%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperItem_StyledButton, {
                                        onClick: onClick,
                                        variant: "primary",
                                        children: (0,i18n.t)("Chọn th\xeam")
                                    })
                                })
                            ]
                        })
                    ]
                }, product.sku);
            })
        ]
    });
};
const HamperItem_StyledCard = (0,emotion_styled_browser_esm["default"])(Card_es/* Card */.Z)(HamperItem_templateObject());
const HamperItem_StyledButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)(HamperItem_templateObject1());
const NameWrapper = (0,emotion_styled_browser_esm["default"])(Col_es/* Col */.JX)(HamperItem_templateObject2());
const Anchor = emotion_styled_browser_esm["default"].a(HamperItem_templateObject3());
const HamperItem_SKU = emotion_styled_browser_esm["default"].span(HamperItem_templateObject4());
const HamperItem_StyledPrice = (0,emotion_styled_browser_esm["default"])(ProductPrice_es/* ProductPrice */.j)(HamperItem_templateObject5());
const StyledRemoveText = (0,emotion_styled_browser_esm["default"])(index_es/* Body */.uT)(HamperItem_templateObject6());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/SearchOutlined.es.js
var SearchOutlined_es = __webpack_require__(877936);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Input.es.js
var Input_es = __webpack_require__(725643);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/BottomSheet/BottomSheet.es.js
var BottomSheet_es = __webpack_require__(811495);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Pagination/Pagination.es.js
var Pagination_es = __webpack_require__(628054);
// EXTERNAL MODULE: ../../packages/utils/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(775002);
// EXTERNAL MODULE: ./components/desktop/organisms/CustomHamper/hamperComponent/HamperGrid.tsx
var HamperGrid = __webpack_require__(901113);
// EXTERNAL MODULE: ./components/mobile/organisms/BuildPC/BuildPCFilterMobile.tsx
var BuildPCFilterMobile = __webpack_require__(344520);
// EXTERNAL MODULE: ./constants/hamper.ts
var constants_hamper = __webpack_require__(467327);
// EXTERNAL MODULE: ./constants/buildpc.ts
var buildpc = __webpack_require__(360339);
// EXTERNAL MODULE: ./constants/search.ts
var search = __webpack_require__(185081);
// EXTERNAL MODULE: ./helpers/discovery.tsx + 1 modules
var discovery = __webpack_require__(681889);
// EXTERNAL MODULE: ./helpers/buildpc.ts
var helpers_buildpc = __webpack_require__(329040);
// EXTERNAL MODULE: ./hooks/usePos365StoreCode.ts
var usePos365StoreCode = __webpack_require__(268055);
// EXTERNAL MODULE: ./hooks/useHamperProducts.ts
var useHamperProducts = __webpack_require__(961247);
// EXTERNAL MODULE: ./modules/search-page/shared/helpers.ts
var helpers = __webpack_require__(774608);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/mobile/organisms/CustomHamper/components/HamperModalComponent.tsx
function HamperModalComponent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HamperModalComponent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HamperModalComponent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function HamperModalComponent_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function HamperModalComponent_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        HamperModalComponent_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function HamperModalComponent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HamperModalComponent_templateObject() {
    const data = HamperModalComponent_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  padding: 0.5rem 0.75rem;\n  position: sticky;\n  top: 0px;\n  z-index: 1040;\n  height: 40px;\n"
    ]);
    HamperModalComponent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HamperModalComponent_templateObject1() {
    const data = HamperModalComponent_taggedTemplateLiteral([
        "\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1rem;\n  font-weight: 700;\n  color: ",
        ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    HamperModalComponent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HamperModalComponent_templateObject2() {
    const data = HamperModalComponent_taggedTemplateLiteral([
        "\n  position: sticky;\n  padding: 0 16px;\n  bottom: 0px;\n  background-color: white;\n"
    ]);
    HamperModalComponent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HamperModalComponent_templateObject3() {
    const data = HamperModalComponent_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  > :first-child {\n    width: 100%;\n    justify-content: center;\n  }\n"
    ]);
    HamperModalComponent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HamperModalComponent_templateObject4() {
    const data = HamperModalComponent_taggedTemplateLiteral([
        "\n  height: calc(\n    100% - 40px - 40px - 50px\n  ); // minus the height of title container, filters & pagination\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n"
    ]);
    HamperModalComponent_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HamperModalComponent_templateObject5() {
    const data = HamperModalComponent_taggedTemplateLiteral([
        "\n  height: calc(\n    100% - 40px - 40px - 50px\n  ); // minus the height of title container, filters & pagination\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n"
    ]);
    HamperModalComponent_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













const ProductList = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(39460)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.ProductList), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const NotFound = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(81633), __webpack_require__.e(2026), __webpack_require__.e(61431), __webpack_require__.e(60687), __webpack_require__.e(89360), __webpack_require__.e(34607), __webpack_require__.e(39890), __webpack_require__.e(39460)]).then(__webpack_require__.bind(__webpack_require__, 539890)).then((mod)=>mod.NoProductsFound), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(539890)
            ]
    }
});
const HamperModalComponent = (props)=>{
    const { collectionSlug , keyword , currentPage , hamperItemKey , onPageChange , activeOptions , activeSortOption , priceFilterValue , setActiveSortOption , setActiveOptions , setPriceFilterValue ,  } = props;
    const { 0: productCardType , 1: setProductCardType  } = (0,react.useState)("grid");
    const { pos365StoreCode  } = (0,usePos365StoreCode/* usePos365StoreCode */.c)();
    const { contactLink  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const [sort, order] = activeSortOption ? (0,helpers/* extractSortQuery */.To)(activeSortOption.optionCode) : [
        undefined,
        undefined
    ];
    // fetch filter block data
    const { filter , loading: filterLoading  } = (0,useHamperProducts/* useHamperProducts */.o)({
        slug: collectionSlug,
        returnFilterable: [
            "FILTER_TYPE_ATTRIBUTE",
            "FILTER_TYPE_BRAND",
            "FILTER_TYPE_PRICE",
            "FILTER_TYPE_CLEARANCE", 
        ],
        pageSize: 1
    });
    // fetch product list
    const { products , pagination , loading: isLoading ,  } = (0,useHamperProducts/* useHamperProducts */.o)({
        slug: collectionSlug,
        query: keyword,
        sorting: (0,discovery/* convertToPayloadSorting */.EN)(sort, order),
        filter: (0,dist_index_es.cleanObject)(HamperModalComponent_objectSpreadProps(HamperModalComponent_objectSpread({}, (0,helpers_buildpc/* convertFilter */.pu)(activeOptions)), {
            priceGte: priceFilterValue === null || priceFilterValue === void 0 ? void 0 : priceFilterValue.gte,
            priceLte: priceFilterValue === null || priceFilterValue === void 0 ? void 0 : priceFilterValue.lte
        })),
        pageSize: constants_hamper/* HAMPER_PAGE_SIZE */.Qi,
        page: currentPage
    }, hamperItemKey);
    const filters = (0,react.useMemo)(()=>{
        return !!filter ? (0,discovery/* convertDiscoveryFilter */.px)(filter) : [];
    }, [
        filter
    ]);
    const priceFilter = (0,react.useMemo)(()=>{
        return (0,helpers/* cookFilterPrice */.kr)(filter === null || filter === void 0 ? void 0 : filter.priceLte, filter === null || filter === void 0 ? void 0 : filter.priceGte);
    }, [
        filter === null || filter === void 0 ? void 0 : filter.priceLte,
        filter === null || filter === void 0 ? void 0 : filter.priceGte
    ]);
    const onSortOptionSelected = (sortOption)=>{
        if (sortOption.optionCode === (activeSortOption === null || activeSortOption === void 0 ? void 0 : activeSortOption.optionCode)) {
            setActiveSortOption(undefined);
        } else {
            setActiveSortOption(sortOption);
        }
    };
    const onSubmit = (activeFilters, filterPriceValue)=>{
        setActiveOptions(activeFilters);
        setPriceFilterValue(filterPriceValue);
    };
    const onClearFilters = ()=>onSubmit([], {
            gte: priceFilter.min,
            lte: priceFilter.max
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageTitleContainer, {
                justify: "start",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        style: {
                            maxWidth: "90%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle, {
                            children: (0,i18n.t)("Chọn sản phẩm")
                        })
                    }),
                    (pagination === null || pagination === void 0 ? void 0 : pagination.totalItems) != undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                        marginLeft: "s4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Title */.Dx, {
                            color: "textSecondary",
                            weight: "regular",
                            style: {
                                fontSize: "0.75rem",
                                lineHeight: "0.75rem"
                            },
                            children: (0,i18n.t)("({{quantity}} sản phẩm)", {
                                quantity: pagination === null || pagination === void 0 ? void 0 : pagination.totalItems
                            })
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildPCFilterMobile/* BuildPCFilterMobile */.Q, {
                loading: filterLoading,
                onClickLayout: ()=>setProductCardType(productCardType === "grid" ? "list" : "grid"),
                layoutType: pos365StoreCode ? "list" : productCardType,
                filters: filters,
                filterPrice: HamperModalComponent_objectSpreadProps(HamperModalComponent_objectSpread({}, priceFilter), {
                    value: priceFilterValue || buildpc/* DEFAULT_PRICE_FILTER */.DT
                }),
                activeSortOption: activeSortOption,
                activeOptions: activeOptions,
                onSortOptionSelected: onSortOptionSelected,
                onSubmit: onSubmit,
                onClearFilters: onClearFilters
            }),
            pos365StoreCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductList, {
                products: products,
                contactLink: contactLink,
                itemsPerPage: !!pagination ? Math.ceil((pagination === null || pagination === void 0 ? void 0 : pagination.totalItems) / (pagination === null || pagination === void 0 ? void 0 : pagination.totalPages)) : search/* ITEM_PER_PAGE_IN_LISTING_PAGE */.p9
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHamperGrid, {
                hamperItemKey: hamperItemKey,
                type: productCardType,
                products: products,
                contactLink: contactLink,
                productsPerRow: 2,
                itemsPerPage: !!pagination ? Math.ceil((pagination === null || pagination === void 0 ? void 0 : pagination.totalItems) / (pagination === null || pagination === void 0 ? void 0 : pagination.totalPages)) : search/* ITEM_PER_PAGE_IN_LISTING_PAGE */.p9
            }),
            !isLoading && (products === null || products === void 0 ? void 0 : products.length) === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotFound, {
                show: true
            }),
            !!pagination ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
                justify: "center",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPagination, {
                    height: "50px",
                    pageNeighbor: 1,
                    totalRecords: pagination === null || pagination === void 0 ? void 0 : pagination.totalItems,
                    currentPage: currentPage,
                    onPageChange: onPageChange
                })
            }) : null
        ]
    });
};
const PageTitleContainer = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(HamperModalComponent_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
});
const PageTitle = emotion_styled_browser_esm["default"].h1(HamperModalComponent_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.textPrimary;
});
const StyledFooter = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(HamperModalComponent_templateObject2());
const StyledPagination = (0,emotion_styled_browser_esm["default"])(Pagination_es/* Pagination */.t)(HamperModalComponent_templateObject3());
const StyledHamperGrid = (0,emotion_styled_browser_esm["default"])(HamperGrid/* HamperGrid */.j)(HamperModalComponent_templateObject4());
const StyledProductList = (0,emotion_styled_browser_esm["default"])(ProductList)(HamperModalComponent_templateObject5());

;// CONCATENATED MODULE: ./components/mobile/organisms/CustomHamper/components/HamperModal.tsx
function HamperModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HamperModal_templateObject() {
    const data = HamperModal_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: auto;\n  .bottom-sheet-header {\n    padding: 8px;\n    height: ",
        ";\n  }\n"
    ]);
    HamperModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






const BOTTOM_SHEET_HEADER_HEIGHT = "57px";
const HamperModalMobile = (props)=>{
    const { collectionSlug , hamperItemKey , visible , onClose  } = props;
    const { 0: keyword , 1: setKeyword  } = (0,react.useState)("");
    const { 0: currentPage , 1: setCurrentPage  } = (0,react.useState)(1);
    const { 0: priceFilterValue , 1: setPriceFilterValue  } = (0,react.useState)();
    const { 0: activeOptions , 1: setActiveOptions  } = (0,react.useState)([]);
    const { 0: activeSortOption , 1: setActiveSortOption  } = (0,react.useState)();
    const onClickSearch = (keyword)=>{
        setKeyword(keyword);
        setCurrentPage(1);
    };
    const clearFilter = ()=>{
        setPriceFilterValue(undefined);
        setActiveOptions([]);
        setActiveSortOption(undefined);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomSheet, {
        show: visible,
        closeBottomSheet: ()=>{
            onClose === null || onClose === void 0 ? void 0 : onClose();
            clearFilter();
        },
        forceRender: true,
        closeIconPosition: "right",
        contentHeight: "calc(100% - ".concat(BOTTOM_SHEET_HEADER_HEIGHT, ")"),
        showBottomSheetHeader: true,
        filterNode: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_es/* Input */.I, {
            placeholder: (0,i18n.t)("T\xecm kiếm"),
            width: "80%",
            marginLeft: "s20",
            onKeyUp: (e)=>{
                const keyword = e.target.value;
                if (e.keyCode === 13) {
                    onClickSearch(keyword);
                }
            },
            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined_es/* SearchOutlined */.l, {
                size: 20
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperModalComponent, {
            collectionSlug: collectionSlug,
            hamperItemKey: hamperItemKey,
            keyword: keyword,
            currentPage: currentPage,
            onPageChange: setCurrentPage,
            activeOptions: activeOptions,
            activeSortOption: activeSortOption,
            priceFilterValue: priceFilterValue,
            setActiveSortOption: setActiveSortOption,
            setActiveOptions: setActiveOptions,
            setPriceFilterValue: setPriceFilterValue
        })
    });
};
const StyledBottomSheet = (0,emotion_styled_browser_esm["default"])(BottomSheet_es/* BottomSheet */.R)(HamperModal_templateObject(), BOTTOM_SHEET_HEADER_HEIGHT);

;// CONCATENATED MODULE: ./components/mobile/organisms/CustomHamper/CustomHamper.tsx
function CustomHamper_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomHamper_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomHamper_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CustomHamper_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function CustomHamper_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        CustomHamper_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function CustomHamper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CustomHamper_templateObject() {
    const data = CustomHamper_taggedTemplateLiteral([
        "\n  margin-bottom: 1rem;\n"
    ]);
    CustomHamper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










const CustomHamper = ()=>{
    const { 0: selectedBomItem , 1: setSelectedBomItem  } = (0,react.useState)();
    const { bomMapping  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { hamperData , changeActiveConfig , updateCurrentConfig , currentHamperConfig , hamperDetailProducts , increaseHamperItemQuantity , removeHamperItem , decreaseHamperItemQuantity , setHamperItemQuantity ,  } = (0,HamperContext/* useHamper */.h)();
    const bomMappingKeys = (0,react.useMemo)(()=>{
        return !!bomMapping && !(0,object_es/* isEmptyObject */.Q)(bomMapping) ? Object.keys(bomMapping) : [];
    }, [
        bomMapping
    ]);
    const onClickBomItem = (hamperItem)=>{
        setSelectedBomItem(hamperItem);
    };
    if ((0,object_es/* isEmptyObject */.Q)(bomMapping) || !bomMapping) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container_es/* Container */.W, {
        padding: "s16",
        width: "100%",
        id: "hamper-item-block",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperTabs, {
                lsActiveTab: hamperData.activeIndex,
                onClickTab: (index)=>{
                    changeActiveConfig(index);
                    (0,helper_es/* trackCustomEvent */.I)("changeHamperConfig", {
                        action: "click",
                        category: "custom_hamper",
                        value: index + 1
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                marginTop: "s16",
                justify: "end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_es/* Button */.z, {
                    variant: "primary",
                    onClick: ()=>updateCurrentConfig({}),
                    children: [
                        (0,i18n.t)("Tạo lại"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshOutlined_es/* RefreshOutlined */.y, {
                            color: "white",
                            size: 16,
                            style: {
                                marginLeft: "0.5rem"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                marginTop: "s16",
                children: bomMappingKeys.map((customHamper)=>{
                    var ref, ref1;
                    const selectedHamper = currentHamperConfig[customHamper] || [];
                    const hampers = hamperDetailProducts.products.filter((hamper)=>{
                        return selectedHamper.map((p)=>p.sku).includes(hamper.sku);
                    }).map((p)=>{
                        var ref;
                        return CustomHamper_objectSpreadProps(CustomHamper_objectSpread({}, p), {
                            quantity: ((ref = selectedHamper.find((h)=>h.sku === p.sku)) === null || ref === void 0 ? void 0 : ref.quantity) || 1
                        });
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHamperItem, {
                        title: bomMapping === null || bomMapping === void 0 ? void 0 : (ref = bomMapping[customHamper]) === null || ref === void 0 ? void 0 : ref.name,
                        icon: bomMapping[customHamper].icon,
                        products: !!hampers && !!Array.isArray(hampers) ? hampers : [],
                        onIncrease: (sku)=>increaseHamperItemQuantity(customHamper, sku),
                        onDecrease: (sku, quantity)=>{
                            quantity === 1 ? removeHamperItem(customHamper, sku) : decreaseHamperItemQuantity(customHamper, sku);
                        },
                        setQuantity: (value, sku)=>{
                            setHamperItemQuantity(customHamper, value, sku);
                        },
                        removeItem: (sku)=>removeHamperItem(customHamper, sku),
                        onClick: ()=>{
                            return onClickBomItem(bomMapping === null || bomMapping === void 0 ? void 0 : bomMapping[customHamper]);
                        }
                    }, bomMapping === null || bomMapping === void 0 ? void 0 : (ref1 = bomMapping[customHamper]) === null || ref1 === void 0 ? void 0 : ref1.type);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperSummary, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HamperModalMobile, {
                collectionSlug: (selectedBomItem === null || selectedBomItem === void 0 ? void 0 : selectedBomItem.slug) || "",
                visible: !!selectedBomItem,
                onClose: ()=>setSelectedBomItem(undefined),
                hamperItemKey: (selectedBomItem === null || selectedBomItem === void 0 ? void 0 : selectedBomItem.type) || ""
            })
        ]
    });
};
const StyledHamperItem = (0,emotion_styled_browser_esm["default"])(HamperItem)(CustomHamper_templateObject());


/***/ }),

/***/ 961247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useHamperProducts; }
/* harmony export */ });
/* harmony import */ var _teko_discovery_dist_v2_useDiscoverySearch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(750180);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(467327);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927890);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(534090);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41796);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(725530);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






const useHamperProducts = (params, hamperItemKey)=>{
    const { discoveryServiceV2 , discoveryHelper  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useServices */ .Su)();
    const { isDisplayUom , showNewProductGift  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { frames  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useFrame */ .x)();
    const { transformProductWhenUserUnder18  } = (0,_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_4__/* .useHandlerUnderEighteenYearOld */ .x)();
    const cartV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useCartV2 */ .T6)();
    const { 0: isOver18Confirmed , 1: setIsOver18Confirmed  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=> true ? localStorage.getItem(helpers__WEBPACK_IMPORTED_MODULE_6__/* .IS_OVER_18_KEY */ .Sj) === "true" : 0);
    // Listen to localStorage changes to trigger re-render hamper cards when user confirms 18+
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handleStorageChange = ()=>{
            const isOver18 = localStorage.getItem(helpers__WEBPACK_IMPORTED_MODULE_6__/* .IS_OVER_18_KEY */ .Sj) === "true";
            setIsOver18Confirmed(isOver18);
        };
        window.addEventListener("storage", handleStorageChange);
        // Sync changes for current tab (since storage event only fires for other tabs)
        const interval = setInterval(()=>{
            const currentValue = localStorage.getItem(helpers__WEBPACK_IMPORTED_MODULE_6__/* .IS_OVER_18_KEY */ .Sj) === "true";
            if (currentValue !== isOver18Confirmed) {
                setIsOver18Confirmed(currentValue);
            }
        }, 100);
        return ()=>{
            window.removeEventListener("storage", handleStorageChange);
            clearInterval(interval);
        };
    }, [
        isOver18Confirmed
    ]);
    const _ref = (0,_teko_discovery_dist_v2_useDiscoverySearch__WEBPACK_IMPORTED_MODULE_7__/* .useDiscoverySearchV2 */ .t)(discoveryServiceV2, _objectSpreadProps(_objectSpread({}, params), {
        isNeedFeaturedProducts: false
    }), {
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, {
                        showUom: isDisplayUom,
                        frames,
                        showNewProductGift,
                        cartV2
                    })),
                filter: data.filter,
                pagination: {
                    totalItems: data.total,
                    totalPages: Math.ceil(data.total / constants_index__WEBPACK_IMPORTED_MODULE_8__/* .HAMPER_PAGE_SIZE */ .Qi)
                }
            };
        }
    }), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const products = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return (result === null || result === void 0 ? void 0 : result.products) || [];
    }, [
        result
    ]);
    const productList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        if (!products.length || !hamperItemKey) return [];
        return products.map(transformProductWhenUserUnder18);
    // eslint-disable-next-line
    }, [
        products,
        transformProductWhenUserUnder18,
        hamperItemKey,
        isOver18Confirmed, 
    ]);
    return _objectSpread({
        products: productList,
        filter: result === null || result === void 0 ? void 0 : result.filter,
        pagination: result === null || result === void 0 ? void 0 : result.pagination
    }, rest);
};


/***/ })

}]);